import React, { useState } from "react";
import axios from "axios";
import { ApiConnectionString } from "../constants/ApiConntection";
import ReCAPTCHA from "react-google-recaptcha";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState("");
  const [sent, setSent] = useState(false);
  const [capVal, setCapVal] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendMessage = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      setStatus("Please fill in all fields.");
      return;
    }

    try {
      setSending(true);
      setStatus("");
      setSent(false);

      await axios.post(`${ApiConnectionString}/api/contactus`, formData);

      setStatus("Message sent. I will get back to you soon.");
      setFormData({
        name: "",
        email: "",
        message: "",
      });
      setSent(true);
      setCapVal(null);
    } catch {
      setStatus("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="row justify-content-center">
      <div className="col-md-8">
        <form
          className="custom-card-light p-4 rounded-4 shadow-sm"
          onSubmit={sendMessage}
        >
          {!sent && (
            <>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="you@example.com"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Tell me about your project"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>

              <div className="my-2 d-flex justify-content-center">
                <ReCAPTCHA
                  sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
                  onChange={(val) => setCapVal(val)}
                />
              </div>
            </>
          )}

          {status && <p className="text-center mb-3">{status}</p>}

          {!sent && (
            <button
              type="submit"
              disabled={sending || !capVal}
              className="btn brand-purple-inline text-white w-100"
            >
              {sending ? "Sending..." : "Send Message"}
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
